import React, { useEffect, useState } from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import Attendance from "./Attendance";
import AttendanceTable from "./AttendanceTable";
import CheckAndReturn from "../../utility/CheckAndReturn";
import { useSelector } from "react-redux";

const AttendancePage = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [fetchTableTrue, setFetchtableTrue] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const { company_id, permissions } = useSelector(
    (state) => state.GlobalVariables
  );


  const handleClickOpen = () => {
    setOpenDialog(!openDialog);
  };

  const handleClose = () => {
    setEditData(null)
    setOpenDialog(false);
    setIsEdit(false)
  };


  const fetchTable = () => {
    // alert("call");
    setFetchtableTrue(prev => !prev);
  };

  const handleEdit = (param) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOpenDialog(true);
    setEditData(param);
    setIsEdit(true);
  };

  const canCreateAttendance = CheckAndReturn.PermissionHandler("create-attendance", permissions);
  return (
    <>
      <CardHeadMenu
        title={"Batch Attendance"}
        handlePopup={canCreateAttendance ? handleClickOpen : undefined}
        create={openDialog}
        disabled={!canCreateAttendance} // ✅ if CardHeadMenu supports disabled prop
      />

      {/* ✅ Show "hello" only when openDialog is true */}
      {openDialog && (
        <Attendance
          handleClose={handleClose}
          fetchTable={fetchTable}
          editData={editData}
          setEditData={setEditData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )}

      <AttendanceTable
        fetchTableTrue={fetchTableTrue}
        handleEdit={handleEdit}

      />
    </>
  );
};

export default AttendancePage;
